module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    ref: "slSucursales",
    staticClass: "form-control",
    attrs: {
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Seleccione un cliente")]), _vm._v(" "), _vm._l((_vm.sucursales), function(sucursal) {
    return (sucursal.empresa) ? _c('option', {
      key: sucursal._id,
      domProps: {
        "value": sucursal._id
      }
    }, [_vm._v(_vm._s(sucursal.empresa.razonSocial) + "-" + _vm._s(sucursal.denominacion))]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe4dcc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ComboEmpresasCliente.vue
// module id = 1141
// module chunks = 5